export const WIDGET_ID = 'CashierCheckoutWidget';
export const ARTIFACT_NAME = 'cashier-express-checkout-widget';
